// import React from "react";

// interface INewsImage {
//   newsImage: string;
//   isDark: boolean;
//   date: string;
//   details: string;
//   category: string;
//   small?: boolean;
//   click: () => void;
// }

// const NewsCol: React.FC<INewsImage> = ({
//   newsImage,
//   isDark,
//   date,
//   details,
//   category,
//   small,
//   click,
// }) => {
//   return (
//     <div
//       onClick={click}
//       className={`flex items-center ${
//         small ? "w-1/2" : ""
//       } justify-start gap-2 p-[4px] cursor-pointer mb-2 ${
//         isDark ? "hover:bg-darkBg" : "hover:bg-lightBg"
//       } cursor-pointer`}
//     >
//       <img className="sm:w-1/3 w-1/2" src={newsImage} alt="sampleNews" />
//       <div className="w-2/3">
//         <h2 className="sm:text-xs text-xs">
//           {category} / {date}
//         </h2>
//         <p
//           className={`${
//             small ? "font-bold sm:text-lg text-sm" : "sm:text-sm text-xs"
//           } text-xs`}
//         >
//           {details.length > 30
//             ? details.split(" ").slice(0, 5).join(" ") + "..."
//             : details}
//         </p>
//       </div>
//     </div>
//   );
// };

// export default NewsCol;

// ----- version 2 -------
import React from "react";

interface INewsImage {
  newsImage: string;
  isDark: boolean;
  date: string;
  details: string;
  category: string;
  small?: boolean;
  click: () => void;
}

const NewsCol: React.FC<INewsImage> = ({
  newsImage,
  isDark,
  date,
  details,
  category,
  small,
  click,
}) => {
  return (
    <div
      onClick={click}
      className={`flex items-center gap-3 p-3 rounded-lg shadow-sm cursor-pointer transition-shadow duration-200 ${
        small ? "w-full sm:w-1/2" : "w-full"
      } ${
        isDark
          ? "bg-darkBg text-white hover:shadow-md"
          : "bg-white text-gray-900 hover:shadow-md"
      }`}
    >
      <img
        className="w-1/3 rounded-md object-cover aspect-square"
        src={newsImage}
        alt="News thumbnail"
      />
      <div className="flex-1">
        <p
          className={`text-xs ${
            isDark ? "text-white" : "text-gray-500"
          } dark:text-gray-400`}
        >
          {category} • {date}
        </p>
        <p
          className={`mt-1 font-medium line-clamp-2 ${
            small ? "text-sm sm:text-base" : "text-xs sm:text-sm"
          }`}
        >
          {details}
        </p>
      </div>
    </div>
  );
};

export default NewsCol;
